import { render } from "./Logo.vue?vue&type=template&id=036a92ce&scoped=true"
const script = {}

import "./Logo.scss?vue&type=style&index=0&id=036a92ce&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036a92ce"]])

export default __exports__